import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

export const PreviewPlaceholderHeaderText = styled.p`
  font: ${token('font.heading.medium')};
  text-align: center;
  width: 400px;
`;

export const PreviewPlaceholderText = styled.p`
  font: ${token('font.body')};
  width: 240px;
  text-align: center;
`;
